import * as React from "react";
import { primaryColor } from "../constants/colors";


const Loader = () => (
  <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ zIndex: 9999 }}>
    <div className="loader-container">
      <svg width="100" height="100" viewBox="0 0 100 100" className="progress-ring">
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="4"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke={primaryColor}
          strokeWidth="4"
          strokeLinecap="round"
          className="progress-circle"
        />
      </svg>

      {/* Logo in Center */}
      <div className="logo-center">
        <div className="logo-circle">
          <span className="logo-text">BDS</span>
        </div>
      </div>
    </div>

    <style jsx>{`
      .loader-container {
        position: relative;
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
      .progress-ring {
        position: absolute;
        top: 0;
        left: 0;
        animation: rotate 2s linear infinite;
      }
      
      .progress-circle {
        stroke-dasharray: 283;
        stroke-dashoffset: 75;
        transform-origin: center;
      }
      
      .logo-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
      }
      
      .logo-circle {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background:${primaryColor};
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 4px 12px rgba(13, 110, 253, 0.3);
        animation: pulse 2s ease-in-out infinite;
      }
      
      .logo-text {
        color: white;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 1px;
      }
      
      @keyframes rotate {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      
      @keyframes pulse {
        0%, 100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.05);
        }
      }
      
      /* Responsive adjustments */
      @media (max-width: 768px) {
        .loader-container {
          width: 80px;
          height: 80px;
        }
        
        .progress-ring {
          width: 80px;
          height: 80px;
        }
        
        .logo-circle {
          width: 50px;
          height: 50px;
        }
        
        .logo-text {
          font-size: 16px;
        }
      }
    `}</style>
  </div>
);

export default Loader;